import { __decorate, __param, __metadata } from 'tslib';
import { Optional, Injectable, NgModule, APP_INITIALIZER } from '@angular/core';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { Subject } from 'rxjs';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common/http';
class RuntimeConfig {
    constructor(obj = {}) {
        this.configUrl = obj.configUrl || './assets/config.json';
    }
}

let RuntimeConfigLoaderService = class RuntimeConfigLoaderService {
    constructor(_http, config) {
        this._http = _http;
        this.configUrl = './assets/config.json';
        this.configSubject = new Subject();
        if (config) {
            this.configUrl = config.configUrl;
        }
    }
    loadConfig() {
        return this._http
            .get(this.configUrl)
            .toPromise()
            .then((configData) => {
            this.configObject = configData;
            this.configSubject.next(this.configObject);
        })
            .catch((err) => {
            this.configObject = null;
            this.configSubject.next(this.configObject);
        });
    }
    getConfig() {
        return this.configObject;
    }
    getConfigObjectKey(key) {
        return this.configObject ? this.configObject[key] : null;
    }
};
RuntimeConfigLoaderService.ɵfac = function RuntimeConfigLoaderService_Factory(t) { return new (t || RuntimeConfigLoaderService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(RuntimeConfig, 8)); };
RuntimeConfigLoaderService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: RuntimeConfigLoaderService, factory: RuntimeConfigLoaderService.ɵfac });
RuntimeConfigLoaderService.ctorParameters = () => [
    { type: HttpClient },
    { type: RuntimeConfig, decorators: [{ type: Optional }] }
];
RuntimeConfigLoaderService = __decorate([ __param(1, Optional()),
    __metadata("design:paramtypes", [HttpClient, RuntimeConfig])
], RuntimeConfigLoaderService);

var RuntimeConfigLoaderModule_1;
function initConfig(configSvc) {
    return () => configSvc.loadConfig();
}
// @dynamic
let RuntimeConfigLoaderModule = RuntimeConfigLoaderModule_1 = class RuntimeConfigLoaderModule {
    static forRoot(config) {
        return {
            ngModule: RuntimeConfigLoaderModule_1,
            providers: [
                {
                    provide: RuntimeConfig,
                    useValue: config,
                },
                RuntimeConfigLoaderService,
            ],
        };
    }
};
RuntimeConfigLoaderModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: RuntimeConfigLoaderModule });
RuntimeConfigLoaderModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function RuntimeConfigLoaderModule_Factory(t) { return new (t || RuntimeConfigLoaderModule)(); }, providers: [
        RuntimeConfigLoaderService,
        {
            provide: APP_INITIALIZER,
            useFactory: initConfig,
            deps: [RuntimeConfigLoaderService],
            multi: true
        },
    ], imports: [[HttpClientModule]] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(RuntimeConfigLoaderService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: RuntimeConfig, decorators: [{
                type: Optional
            }] }]; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(RuntimeConfigLoaderModule, { imports: function () { return [HttpClientModule]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(RuntimeConfigLoaderModule, [{
        type: NgModule,
        args: [{
                imports: [HttpClientModule],
                providers: [
                    RuntimeConfigLoaderService,
                    {
                        provide: APP_INITIALIZER,
                        useFactory: initConfig,
                        deps: [RuntimeConfigLoaderService],
                        multi: true
                    },
                ]
            }]
    }], null, null); })();

/*
 * Public API Surface of runtime-config-loader-lib
 */

/**
 * Generated bundle index. Do not edit.
 */

export { RuntimeConfig, RuntimeConfigLoaderModule, RuntimeConfigLoaderService, initConfig };

//# sourceMappingURL=runtime-config-loader.js.map